import { render } from "./SelectPlatforms.vue?vue&type=template&id=5dd5b8f9&scoped=true"
import script from "./SelectPlatforms.vue?vue&type=script&lang=js"
export * from "./SelectPlatforms.vue?vue&type=script&lang=js"

import "./SelectPlatforms.vue?vue&type=style&index=0&id=5dd5b8f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd5b8f9"]])

export default __exports__